<template>
    <div :class="`buy-now-dialog-container ${pageTakeover ? 'static' : 'modal'}`" ref="modal">
        <div class="buy-now-dialog">
                <div v-if="multiple && items.length > 1" class="buy-now-dialog__header">
                    <div class="multi-items-header">
                        <span class="buy-now-headline">Place Your Order </span>
                        <span class="buy-now-qty">
                            ({{ items.length }} item{{ items.length > 1 ? 's' : '' }})
                        </span>
                    </div>
                    <div style="grid-column: span 6; display: flex">
                        <div v-for="item in items.slice(0, 4)" :key="item.itemid" class="multi-item-image">
                            <img :src="checkImg(item.image, item.itemid)" :alt="item.productname">
                        </div>
                        <div class="multi-item-image__more" v-if="items.length > 4">
                            +{{ items.length - 4 }}
                        </div>
                    </div>
                    <div class="buy-now-dialog__header-exit" v-if="!placingOrder">
                        <button @click="closeModal()" class="svg-wrap" aria-label="Close the buy now window.">
                            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <title>close</title>
                            <line x1="1.70711" y1="0.792893" x2="17.7071" y2="16.7929" stroke="#747474" stroke-width="2"/>
                            <line x1="1.29289" y1="16.7929" x2="17.2929" y2="0.792894" stroke="#747474" stroke-width="2"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <div v-else class="buy-now-dialog__header">
                    <div class="buy-now-dialog__header-image">
                        <img width="70px" :src="singleItem.image" alt="">
                    </div>
                    <div class="buy-now-dialog__header-details">
                        <b>Buy Now:</b>
                        <br>
                        <h2>{{ singleItem.name }}</h2>
                        <rating-stars v-if="singleItem.rating" :rating="singleItem.rating" size="sm" />
                    </div>
                    <div class="buy-now-dialog__header-exit" v-if="!placingOrder">
                        <button @click="closeModal()" class="svg-wrap">
                            
                            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <title>close</title>
                            <line x1="1.70711" y1="0.792893" x2="17.7071" y2="16.7929" stroke="#747474" stroke-width="2"/>
                            <line x1="1.29289" y1="16.7929" x2="17.2929" y2="0.792894" stroke="#747474" stroke-width="2"/>
                            </svg>

                        </button>
                    </div>
            </div>
                <div class="buy-now-dialog__body">
                    <one-click-checkout-summary-loader v-if="loading"></one-click-checkout-summary-loader>
                    <one-click-checkout-summary @clicked-checkout-step="goToCheckout" @load="loading = true" :user-info="userInfo" v-else-if="userInfo?.prepared" :multi-item="multiple && items.length > 1" :showEdit="fullCheckoutButton"></one-click-checkout-summary>                    
                    
                    <div v-if="placingOrder" class="buy-now-placing">
                        <div>
                            <strong>Important: </strong><br />
                            Don't leave or refresh this page. 
                        </div>
                    </div>
                </div>
                <div v-if="!loading && userInfo?.prepared" class="product-action__cart" style="width: auto;">

                    <a href="#" @click.prevent="() => goToCheckout('/store/checkout/')" id="buy-now-makechanges"  v-if="userInfo?.next_url">
                        Make Changes
                    </a>

                    <button type="button" id="buy-now-placeorder" @click.prevent="placeOrder" v-if="userInfo?.next_url">
                        Place Your Order
                    </button>
                    

                    <slide-to-submit @userRequestsSubmit="placeOrder" v-if="userInfo?.next_url"/>

                    
                </div>
        </div>
    </div>
</template>

<script>
import logBuyNowRedirectToCheckoutReason from '../logBuyNowRedirectToCheckoutReason';

    let abortController = null;
    const defaultUserInfo = {
        prepared: false,
        shipping: {
            name: "",
            address_lines: [],
            delivery_date: null,
        },
        cc: {
            type: "",
            number: ""
        },
        pricing: {
            sub_total: null,
            shipping: null,
            tax_estimate: null,
            order_total: null,
        },
        next_url: null
    };

    function createAbortController() {
        abortController = new AbortController();
        return abortController;
    }

    export default {
        components: {
            'one-click-checkout-summary': require('../OneClickCheckoutSummary.vue').default,
            'one-click-checkout-summary-loader': require('../OneClickCheckoutSummaryLoading.vue').default,
            'slide-to-submit': require('../SlideToSubmit.vue').default
        },
        props: {
            pageTakeover: {
                require: false,
                default: false,
                type: Boolean,
            },
            referrer: {
                required: false,
            },
            productImage: {
                required: false,
            },
            starRating: {
                required: false,
            },
            productName: {
                required: false,
            },
            buyNowUrl: {
                required: false,
            },
            singleItemid: {
                required: false,
            },
            items: {
                type: Array,
            },
            multiple: {
                required: false,
                type: Boolean,
                default: false,
            },
            fullCheckoutButton: {
                // only for use on the cart page
                required: false,
                type: Boolean,
                default: false
            }
        },
        computed: {
            singleItem() {
                const backupItem = (Array.isArray(this.items) && this.items[0]) || {};
                return {
                    image: this.productImage || backupItem.image,
                    name: this.productName || backupItem.productname ||  backupItem.productName,
                    rating: this.starRating
                }
            },
        },
        watch: {
            tabIsActive(tabIsActive) {
                // console.log({ tabIsActive});
            }
        },
        data() {
            return {
                preventRevertOnDestroy: false,
                tabIsActive: true,
                loading: false,
                placingOrder: false,
                userInfo: {
                    ...defaultUserInfo
                },
                _userInfo: {
                    prepared: true,
                    shipping: {
                        name: "Billy",
                        address_lines: [
                            "123 Test St.",
                            "Apt. G",
                            "Mobile, Alabama 76893"
                        ],
                        delivery_date: "4/20/24",
                    },
                    cc: {
                        type: "Visa",
                        number: "************4242"
                    },
                    pricing: {
                        sub_total: 1510.88,
                        shipping: 0,
                        tax_estimate: 105.77,
                        order_total: 1616.65,
                    },
                    next_url: null
                },
            }
        },
        mounted() {
            this.boot();

            document.addEventListener("visibilitychange", () => {
                if (document.hidden) {
                    this.tabIsActive = false;
                    this.$emit('close');
                } else {
                    this.tabIsActive = true;
                }
            });

            document.body.classList.add('noscroll');


            // prevent double logging due to this component being loaded 2x
            function doesImpressionExist() {
                for (var i = 0; i < window.dataLayer.length; i++) {
                    if (window.dataLayer[i]['event'] === 'buyNow') {
                        return true;
                    }
                }
                return false;
            }

            if(!doesImpressionExist() && this.referrer){
                if(this.referrer === 'pdp') {
                    window.dataLayer.push({
                        'event': 'buyNow',
                        'buyNowAction': 'pdpImpression'
                    });
                } else if(this.referrer === 'minicart') {
                    window.dataLayer.push({
                        'event': 'buyNow',
                        'buyNowAction': 'minicartImpression',
                    });
                } else if (this.referrer === 'pdp-withQty') {
                    window.dataLayer.push({
                        'event': 'buyNow',
                        'buyNowAction': 'pdpQtyImpression',
                    });
                }
            }
        },
        beforeDestroy() {
            if (!this.preventRevertOnDestroy) {
                this.revertBuyNow('before destroy');
            }
            window._buyNowLock = false;
            document.body.classList.remove('noscroll');
        },
        methods: {
            goToCheckout(url) {
                this.preventRevertOnDestroy = true;
                this.$nextTick(() => {
                    window.location.href = url;
                });
            },
            redirect(url) {
                window._redirecting = true;
                window.location.href = url;
            },
            boot() {
                if (window._buyNowLock) {
                    return;
                }
                window._buyNowLock = true;
                this.loading = true;
                this.addItemToCart()
                    .then(this.fetchUserCheckoutInfo)
                    .then(response => {
                        if (response instanceof String && this.tabIsActive) {
                            logBuyNowRedirectToCheckoutReason('fetch-response-string')
                                .then(() => {
                                    this.redirect('/store/cart.php?reason=fetch-response-string');
                                });
                        }
                        if (response) {
                            window._buyNowLock = false;
                            if (response.redirect_to && this.tabIsActive) {
                                this.placingOrder = true;
                                this.redirect(response.redirect_to);
                            } else if (!response.prepared && this.tabIsActive) {
                                this.placingOrder = true;
                                logBuyNowRedirectToCheckoutReason('client-not-prepared')
                                    .then(() => {
                                        this.redirect(response.redirect_to || '/store/checkout/one-click/?method=shippingmethod&reason=client-not-prepared');
                                    });
                            } else {
                                this.loading = false;
                                this.userInfo = response;
                                this.$emit('booted');
                            }
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        if (this.tabIsActive) {
                            logBuyNowRedirectToCheckoutReason('caught-fetch-error')
                                .then(() => {
                                    this.redirect('/store/checkout/?reason=caught-fetch-error');
                                });
                        }
                    });
            },
            handleTabKey(event) {
                // TODO - trap tab focus

                // const modal = this.$refs.modal;
                // const focusedElement = document.activeElement;
                // console.log(focusedElement);

                // if (!modal.contains(focusedElement)) {
                //     // If the focused element is not within the modal, prevent default tab behavior
                //     // and focus the first focusable element within the modal
                //     event.preventDefault();
                //     modal.querySelector('input, button, [tabindex]:not([tabindex="-1"])').focus();
                // }
            },
            closeModal() {
                window.dataLayer.push({
                        'event': 'buyNow',
                        'buyNowAction': 'closeModal',
                });
                this.$emit('close');
            },
            addItemToCart() {
                if (this.multiple || !this.tabIsActive) {
                    return this.revertBuyNow('item added to cart, is multiple or not active tab')
                        .then(() => {
                            return {
                                next_fetch: '/store/checkout/one-click/'
                            }
                        });
                }
                return axios.get(this.buyNowUrl, { signal: createAbortController().signal })
                    .then(r => r.data)
                    .catch(this.handleFetchingError);
            },
            fetchUserCheckoutInfo({ next_fetch }) {
                if (!this.tabIsActive) {
                    return Promise.resolve();
                }
                return axios.get(next_fetch, { signal: createAbortController().signal })
                    .then(r => r.data)
                    .catch(this.handleFetchingError);
            },
            placeOrder() {
                if (document.querySelector('#buy-now-placeorder')) {
                    document.querySelector('#buy-now-placeorder').classList.add('ordering');
                }
                if (this.userInfo.next_url) {
                    this.placingOrder = true;
                    if (this.tabIsActive) {
                        window.dataLayer.push({
                            'event': 'buyNow',
                            'buyNowAction': 'submit',
                        });
                        this.redirect(this.userInfo.next_url);
                    }
                }
            },
            handleFetchingError() {
                this.revertBuyNow('handle fetch error').then(() => {
                    this.$emit('close');
                    window._buyNowLock = false;
                });
            },
            revertBuyNow(reason = '') {
                if (abortController) {
                    abortController.abort();
                }
                if (this.placingOrder || window._redirecting) {
                    return Promise.resolve();
                }
                this.userInfo = {
                    ...defaultUserInfo,
                }
                if (window._revertingBuyNow) {
                    return Promise.resolve();
                }
                window._revertingBuyNow = true;
                return axios.get(`/store/checkout/buy-now/revert/?async=true&from=buy-now-modal&reason=${reason}`)
                    .then(() => window._revertingBuyNow = false);
            },
            checkImg(url, itemid){
                if(itemid.includes('InstallGNutB')){
                    return "https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerBone-square.jpg?width=200";
                } else if(itemid.includes('InstallGNutT')){
                    return "https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerTusq-square.jpg?width=200";
                } else if(itemid.includes('InstallGS')){
                    return "https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerSetup-square.jpg?width=200";
                } else if(itemid.includes('InstallGPlek')){
                    return "https://media.sweetwater.com/m/images/store/cart/guitarServiceBannerPlek-square.jpg";
                } else {
                    return url;
                }
            },
        },
        destroyed() {
            document.removeEventListener('keydown', this.handleTabKey);
        },
    }
</script>

<style lang="scss" scoped>

.multi-items-header {
    grid-column: span 8;
    margin-bottom: 0.5em;

    span.buy-now-headline {
        font-size: 1.2em !important;
        font-weight: bold;
        display: inline !important;
    }
    span.buy-now-qty {
        opacity: 0.7;
        font-size: 0.9em;
    }
}

.multi-item-image {
    box-shadow: 0 0 10px #d5d5d5;
    border: 3px solid #fff;
    border-radius: 50%;
    position: relative;
    background: #fff;
    overflow: hidden;
    width: 32px;
    height: 32px;
    margin-right: -10px;

    &:first-of-type {
        left: 0px;
    }

    img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        object-fit: contain;
    }
}

.multi-item-image__more {
    align-items: center;
    background: #fff;
    border-radius: 50%;
    box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.12);
    color: #555;
    display: flex;
    height: 32px;
    justify-content: center;
    position: relative;
    width: 32px;
}

.buy-now-dialog-container {
    align-items: center;
    backdrop-filter: blur(2px);
    display: flex;
    height: 100dvh;
    justify-content: center;
    overflow: auto;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    max-width: 100%;
    z-index: 999;
    text-align: left;
    position: fixed;

    &.static {
        .buy-now-dialog__header-exit {
            display: none;
        }
    }
}

.buy-now-dialog {
    background: #fff;
	box-shadow: 0px 0px 100px 300vw rgb(0, 0, 0, .45);
	border-radius: 6px;
    border: none;
	width: 400px;
    max-width: 100%;
	padding: 0px;
    margin: auto;
	overflow: hidden;
    position: relative;

    @keyframes rotate{
        from {
            transform: rotate(-360deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

	.rating__stars {
		background-color: transparent;
	}

	@media screen and (max-width: 600px) {
		width: 100vw;
        position: fixed;
        bottom: 0;
	}

	&__header {
		padding: 18px 14px;
		background-color: #e3e6ec;
		display: grid;
		grid-template-columns: repeat(8, minmax(0, 1fr));
		align-items: center;

		&-image, &-exit {
			grid-column: span 2;
			text-align: center;
		}

		&-image {
			img {
                background-color: #fff;
                object-fit: contain;
                height: 70px;
				border-radius: 100%;
				width: 70px;
                border: 4px solid #fff;
			}
		}

		&-exit {
            position: absolute;
            top: 1em;
            right: 1em;

			.svg-wrap {
                background: #e3e6ec;
				border-radius: 100%;
				padding: 6px;
				display: flex;
				width: 50px;
				height: 50px;
				margin: auto;
				align-items: center;
				justify-content: center;
				border: none;
				cursor: pointer;

                &:hover {
				    background: #d7dae0;
                    svg path {
                        fill: #282828;
                    }
                }

				svg {
					height: 1.25rem;
					width: 1.25rem;

					path {
						fill: #747474;
					}
				}
			}
		}

		&-details {
			grid-column: span 4;

			b {
				color: #3b7d1a;
			}
			h2 {
				font-size: 1em !important;
			}
		}
	}

	&__body {
        position: relative;
        
        b {
            font-weight: 600;
            color: #202020;
        }
	}

	.product-action__cart {
		background-color: #e3e6ec;
		padding: 24px;
		max-width: 100%;
        text-align: center;
		
		button {
			width: 100%;
		}
	}
}

.buy-now-placing {
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(255,255,255,.9);
    backdrop-filter: blur(2px);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
}

@keyframes spin {
     0% {transform: rotate(0deg)}
     100% {transform: rotate(360deg)}
   }

#buy-now-placeorder {
    -webkit-appearance: none;
    appearance: none;
    background: #3b7d1a;
    border-radius: 50px;
    border: none;
    color: #fff;
    cursor: pointer;
    display: block;
    font-size: 18px;
    font-weight: 600;
    margin: 0 auto;
    max-width: 300px;
    line-height: 1.2em;
    outline-offset: 2px;
    padding: 1rem 1rem;

    &:hover {
        filter: brightness(1.1);
    }
}

a#buy-now-makechanges {
    -webkit-appearance: none;
    appearance: none;
    background: #ccccd8;
    box-sizing: border-box;
    border-radius: 50px;
    border: none;
    color: #585858;
    cursor: pointer;
    display: block;
    font-size: 18px;
    margin: 0 auto .75em auto;
    line-height: 1.2em;
    max-width: 300px;
    outline-offset: 2px;
    padding: 1rem 1rem;
    text-decoration: none;

    &:hover {
        color: #222!important;
        filter: brightness(.95);
    }
}

#buy-now-placeorder.ordering {
    color: #3b7d1a;
    position: relative;
    pointer-events: none;

    &::before {
        content: '';
        animation: spin 1s infinite;
        border-radius: 30px;
        border: 2px dotted #fff;
        display: block;
        height: 1em;
        left: 50%;
        margin-left: -.5em;
        margin-top: -.5em;
        position: absolute;
        top: 50%;
        width: 1em;
    }
}

.s2s {
    display: none;
}
</style>